import DimensionListView from './DimensionListView';

export default DimensionListView;
